import React from "react";
import SiteHead from "../component/head/SiteHead";
import SiteAppNoSSR from "../component/app/SiteAppNoSSR";
import Link from "next/link";
import { useWebsiteRoutePathname } from "../component/hooks";
import { generateLoginPath } from "../pixelmixer-webapp/src/service/AmplifyLoginService";
import Footer from "../component/footer/Footer";
import LandingPageContent from "./landingPage/LandingPageContent";

const SignupPage = ({ nonce }) => {
  const pathname = useWebsiteRoutePathname();

  return (
    <>
      <SiteHead showNavBar={true} nonce={nonce} />
      <div className="form-page-container signup">
        <div className="container">
          <div className="row  justify-content-center s">
            <LandingPageContent />

            <div className="col-lg-5">
              <div className="form-panel heading6">
                <h2 className="title">
                  <ion-icon name="happy-outline" class="icons"></ion-icon>
                  Try for Free
                </h2>
                <div className="space16"></div>
                <p className="text-center">Let's get you started.</p>
                <div className="space50"></div>
                <SiteAppNoSSR />
                <div className="space32"></div>
                <div className="col-md-12 text-center">
                  <p className="create-account">
                    Already have an account?&nbsp;
                    <Link
                      href={generateLoginPath(pathname)}
                      className="purple-color"
                    >
                      Login here
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer includeSignup={false} />
    </>
  );
};

export default SignupPage;
